"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleVatCheckErrorResponse = exports.handleRegistrationErrorResponse = void 0;
const react_toastify_1 = require("react-toastify");
const array_1 = require("../../common/js/helper/array");
const translation_1 = require("../../common/js/helper/translation");
const RegistrationErrorCodes_1 = __importDefault(require("../enums/RegistrationErrorCodes"));
const handleRegistrationErrorResponse = (response) => {
    const code = (0, array_1.first)(response?.errors ?? [])?.code;
    switch (code) {
        case RegistrationErrorCodes_1.default.commonConstraintViolation: {
            react_toastify_1.toast.error((0, translation_1.t)('registration.error.bad_data'));
            break;
        }
        case RegistrationErrorCodes_1.default.duplicatesDetected: {
            react_toastify_1.toast.error((0, translation_1.t)('registration.error.duplicate'));
            break;
        }
        default: {
            react_toastify_1.toast.error((0, translation_1.t)('registration.error.fallback'));
        }
    }
    return Promise.resolve();
};
exports.handleRegistrationErrorResponse = handleRegistrationErrorResponse;
const handleVatCheckErrorResponse = (response) => {
    const code = (0, array_1.first)(response?.errors ?? [])?.meta?.violationCode;
    switch (code) {
        case 'f5581e92-b6a5-4639-aab5-3a24a002ab81': {
            return Promise.resolve('unreachable_tax_validation');
        }
        default: {
            return Promise.resolve('invalid_tax_id');
        }
    }
};
exports.handleVatCheckErrorResponse = handleVatCheckErrorResponse;
